import React from "react";
import { useParams } from "react-router-dom";
import { portfolioData } from "../portfolioData";
import "./DetailPortfolio.css";

const DetailPortfolio = () => {
  const { projectId } = useParams();

  const allProjs = portfolioData.flatMap(section => section.projects);
  const project = allProjs.find(p => p.id === projectId);

  if (!project) {
    return <h1 className="noPortfolio">Project not found</h1>;
  }

  return (
    <section className="detailPortfolioSection">
      <div className="detailPortfolioWrapper">

        <img src={project.image} alt={project.title} className="detailPortfolioImg" />

        <h1 className="detailPortfolioTitle">{project.title}</h1>
        <p className="detailPortfolioDesc">{project.description}</p>

        <div className="detailPortfolio">
          <p><strong>Category:</strong> {
            portfolioData.find(section => section.projects.some(p => p.id === projectId))
            ?.category
          }</p>
          <p><strong>Project ID:</strong> {projectId}</p>
        </div>

      </div>
    </section>
  );
};

export default DetailPortfolio;
